import forge from 'apis/forge';
import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { NEW_CHAT_TITLE } from 'dragonmouse-shared/constants';
import { ChatStatus } from 'dragonmouse-shared/interfaces';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectActiveDesignSystem } from 'redux/db/reducers';
import { setActiveDsChatId } from 'redux/mode/actions';
import { RootReducer } from 'redux/reducers';
import { v4 as uuid } from 'uuid';

const NewChatAction = () => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const designSystem = useSelector((r: RootReducer) =>
		selectActiveDesignSystem(r.db, r.mode.activeDesignSystemId)
	);

	const onClick = async () => {
		if (!designSystem || isLoading) return;
		setIsLoading(true);
		try {
			const chatId = uuid();
			await forge.createDsChat({
				id: chatId,
				designSystemId: designSystem.id,
				title: NEW_CHAT_TITLE,
				metadata: { status: ChatStatus.PROCESSING, statusMessage: 'Initializing chat...' },
			});
			dispatch(setActiveDsChatId(chatId));
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<ActionButton
			icon={IconType.CHAT_NEW}
			label="Start a fresh chat"
			loadingLabel="Creating new chat..."
			isLoading={isLoading}
			onClick={onClick}
		/>
	);
};

export default NewChatAction;
